<template>
    <div class="layout">
        <!-- 因为不能遮住弹窗 <pp-header></pp-header> -->
        <pp-main class="flex_div"></pp-main>
        <!-- <pp-footer v-if="$route.meta.showFooter"></pp-footer> -->
    </div>
</template>
<script>
// 母版页
// import ppHeader from './header.vue';
import ppMain from './main.vue';
// import ppFooter from './footer.vue';

export default {
    name: 'layout',
    components: {
        // ppHeader,
        ppMain
        // ppFooter
    },
    data() {
        return {};
    }
};
</script>
<style lang="scss" scoped>
.layout {
	width:100%;
	height: 1080px;
	// overflow-y: hidden;
	overflow: hidden;
}

.flex_div {
    width:100%;
	min-width: 1920px;
    height: 100%;
	// overflow: hidden;
	// overflow-y: hidden;
	background: url('../image/bg.png') no-repeat center center;
    background-size: cover;
}
</style>
